import React, { useEffect, useMemo, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { IMAGES, BUYER_NAMES, BUYER_LOCATIONS } from '../data/landing';
interface Purchase {
  name: string;
  location: string;
  minutes: number;
}
const FIRST_DELAY = 10000;
const INTERVAL = 20000;
const DURATION = 6000;
function buildQueue(): Purchase[] {
  const items: Purchase[] = BUYER_LOCATIONS.map((location, index) => ({
    location,
    name: BUYER_NAMES[index % BUYER_NAMES.length],
    minutes: 2 + index * 5 % 27
  }));
  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
  return items;
}
export function PurchaseNotification() {
  const queue = useMemo(buildQueue, []);
  const [index, setIndex] = useState(0);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    let hideTimer = 0;
    let interval = 0;
    const show = () => {
      setShown(true);
      hideTimer = window.setTimeout(() => {
        setShown(false);
        setIndex(current => (current + 1) % queue.length);
      }, DURATION);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [queue.length]);
  const purchase = queue[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-[86px] left-3 z-40 w-[268px] sm:left-5 sm:w-[300px]" data-id="element-151" data-mp="19o3pj2tepb6c">
      <div className={`flex items-center gap-2.5 rounded-[12px] border border-line bg-cream-soft px-2.5 py-2 shadow-[0_10px_28px_-16px_rgba(18,17,15,0.4)] transition-[opacity,transform] duration-200 ease-out ${shown ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-152" data-mp="zrqw861rwzc4">
        <img src={IMAGES.heroMockup} alt="" width={64} height={64} loading="lazy" decoding="async" className="h-9 w-9 flex-none rounded-[7px] object-cover" data-id="element-153" data-mp="vpx26gm32tkx" />
        <div className="min-w-0 flex-1" data-id="element-154" data-mp="2smrvhyq7lzpz">
          <p className="text-[11px] font-bold leading-snug text-ink" data-id="element-155" data-mp="2noq9p61efmat">
            {purchase.name} de {purchase.location}
          </p>
          <p className="text-[10px] font-medium leading-snug text-ink-muted" data-id="element-156" data-mp="2jopkqrgobspi">
            compró el producto + bonos
          </p>
          <p className="text-[9px] font-medium text-ink-muted/70" data-id="element-157" data-mp="3gbkrtwaqu9l4">
            hace {purchase.minutes} minutos
          </p>
        </div>
        <CheckCircle2Icon className="h-4 w-4 flex-none text-[#4E7A4A]" aria-hidden="true" data-id="element-158" data-mp="37ch8cr7nzs63" />
      </div>
    </div>;
}